import React from 'react';
import PropTypes from 'prop-types';
import { isMobileOnly } from 'react-device-detect';
import QuestionHead from '../QuestionHead';
import MobileSelector from './MobileSelector';
import Option from './Option';
// ROOT (type of hearing loss) and SN-ROOT (Sensorineural)
import easImg from '../../../img/EAS_SNHL_IND_01.jpg';
import ciImg from '../../../img/CI_SNHL_IND_01.jpg';
import vsbImg from '../../../img/VSB_SNHL_IND_01.jpg';
import Footer from '../../common/Footer';

function Selector({
  buttons, onClick, head, question,
}) {
  const handleBigScreenSelect = (event) => {
    event.preventDefault();
    const { target } = event;
    const button = buttons.find(x => x.label === target.name);
    onClick(button);
  };
  /** This is a hack for the audiograms */
  const getImage = (name) => {
    if (!name) return null;
    if (name.startsWith('EAS')) return easImg;
    if (name.startsWith('CI')) return ciImg;
    if (name.startsWith('VSB')) return vsbImg;
    return null;
  };

  if (isMobileOnly) {
    return (
      <>
        <div className="container">
          <QuestionHead head={head} />
        </div>
        <MobileSelector buttons={buttons} onConfirm={onClick} importImage={getImage} />
        <Footer />
      </>
    );
  }
  const bigScreenCss = question
    ? 'd-flex flex-wrap px-1'
    : 'd-flex justify-content-center px-1';
  return (
    <>
      <div className="container">
        <QuestionHead head={head} />
      </div>

      <div className="container">
        <div className={bigScreenCss}>
          {buttons.map(x => (
            <div className="px-2 mt-0 mb-3" style={{ width: 340, maxWidth: 340 }} key={x.label}>
              <Option
                title={x.title}
                label={x.label}
                onSelect={handleBigScreenSelect}
                description={x.description}
                image={getImage(x.image)}
              />
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </>
  );
}

Selector.propTypes = {
  buttons: PropTypes.arrayOf(PropTypes.any).isRequired,
  onClick: PropTypes.func.isRequired,
  head: PropTypes.string.isRequired,
  question: PropTypes.string,
};

Selector.defaultProps = {
  question: null,
};

export default Selector;
